import gsap from 'gsap';

import { BaseBonusBoardDrawer } from './BaseBonusBoardDrawer';
import { mobileBonusBoardResources } from '../../../core/mobileResources';
import { mobileBonusBoardRssNames } from '../../../core/mobileResourceNames';
import { gameMobileConfig } from '../../../core/configs';
import {getTranslation, translationKeys} from '../../../core/translation/translation';
import {
  HAS_BUY_BONUS,
  SPIN_AMOUNT,
  SPIN_AMOUNT_ACTIVE,
  WHEEL_ROTATION_STATE,
} from '../../../stateManagment/gameState';
import { BONUS_AMOUNT_MULTIPLE, FONT_BALOO_NAME, FONT_LATO_NAME } from '../../../core/constats';
import { amountFormatter } from '../../../core/helpers/amountFormatter';
import { partnerService } from '../../../services/helperService/PartnerService';
import { debounce } from '../../../core/helpers/debounce';
import { popupHelper } from '../../../services/helperService/PopupHelper';
import { soundService } from '../../../services/helperService/PixiSoundService';
import { buyBonusButtonHelper } from '../../../services/helperService/BuyBonusButtonHelper';
import { gamePadDrawer } from '../../gamePad/GamePadDrawer';
import {gameDrawer} from "../../../game/GameDrawer";

export class BonusBoardMobileDrawer extends BaseBonusBoardDrawer {
  constructor() {
    super();
    this.container = null;
    this.loader = this.createLoader();
    this.resources = null;
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(mobileBonusBoardResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  setupPosition() {
    this.setPosition(this.container, gameMobileConfig.buyBonusPosition);
  }

  _handleBonusButtonClick({ texture }) {
    return debounce(() => {
      if (buyBonusButtonHelper.state && !WHEEL_ROTATION_STATE.getValue()) {
        gsap.to(texture, { duration: .1, pixi: { scale: .9 } });
        gsap.to(texture, { delay: .1, duration: .2, pixi: { scale: 1 } });
        popupHelper.setBuyBonusPopupState(true);
      }
    }, 300, true);
  }

  setBonusButton() {
    const w = 245;
    const h = 82;
    const bonusButton = this.createSpine(this.resources[mobileBonusBoardRssNames.bonus_buttonAnimation]);
    bonusButton.scale.set(1.2)
    this.setPosition(bonusButton, { x: gameMobileConfig.width / 2, y:  h / 2  });
    const bonusRect = this.createGraphics()
      .drawRect(
        (gameMobileConfig.width - w) / 2,
        0,
        w,
        h,
      );

    this.setPosition(bonusButton, { x: gameMobileConfig.config.width / 2, y: h / 2 });
    bonusButton.interactive = true;
    bonusButton.buttonMode = true;
    this.addSubscriber(WHEEL_ROTATION_STATE.subscribe(wheelRotationState => {
      bonusButton.alpha = wheelRotationState ? .7 : 1;
    }, true));
    bonusButton.on('pointerdown', event => {
      event.stopPropagation();
      gamePadDrawer.resetOpenedState();
      soundService.playBuyBonusClick();
      this._handleBonusButtonClick({ texture: bonusButton })();
    });

    const buyBonusText = new this.PIXI.Text(`${getTranslation(translationKeys.BUY_BONUS)}`, {
      fontFamily: FONT_LATO_NAME,
      fontSize: 27.5,
      align: 'center',
      fontWeight: 900,
      fill: 0xFFFFFF,
      dropShadowColor: 0x296d1e,
      dropShadowAlpha: .5,
      dropShadowBlur: 1,
      dropShadowDistance: 4,
      dropShadow: true,
    });

    const amountText = new this.PIXI.Text('', {
      fontFamily: FONT_BALOO_NAME,
      fontSize: 25,
      align: 'center',
      fontWeight: 900,
      fill: 0xFFFFFF,
      dropShadowColor: 0x296d1e,
      dropShadowAlpha: .5,
      dropShadowBlur: 1,
      dropShadowDistance: 4,
      dropShadow: true,
    });

    this.addSubscriber(SPIN_AMOUNT_ACTIVE.subscribe((index) => {
      amountText.text = `${amountFormatter.format(SPIN_AMOUNT.getValue()[index] * BONUS_AMOUNT_MULTIPLE)} ${partnerService.displayCurrency}`;
    }, true));

    // shine

    this.__timer = setInterval(() => {
      bonusButton.state.setAnimation(0, 'shine', false);
    }, 2000);


    buyBonusText.anchor.set(.5, .8);
    amountText.anchor.set(.5, 0);
    bonusButton.addChild(
      buyBonusText,
      amountText,
    );
    bonusRect.addChild(bonusButton);
    this.container.addChild(bonusRect);
    this.addSubscriber(HAS_BUY_BONUS.subscribe(state => {
      this.container.visible = state;
    }, true))
  }

  async onLoad() {
    return this.loadResource();
  }

  destroy() {
    clearInterval(this.__timer);
    super.destroy();
  }

  async executeMainScene(root) {
    await this.loadResource();
    this.setupPosition();
    this.setBonusButton();
  }
}
